const fallbackTheme = {
  primary: '#087f5b',
  deep: '#0b4d3a',
  soft: '#e7f5ef',
  grid: '#dce8e2',
  text: '#20352d',
  muted: '#718092',
  danger: '#d1495b',
};

const token = (styles, name, fallback) => styles?.getPropertyValue(name).trim() || fallback;

export const readTenantChartTheme = () => {
  if (typeof window === 'undefined') return fallbackTheme;
  const styles = window.getComputedStyle(document.documentElement);
  return {
    primary: token(styles, '--theme-primary', fallbackTheme.primary),
    deep: token(styles, '--theme-deep', fallbackTheme.deep),
    soft: token(styles, '--theme-soft', fallbackTheme.soft),
    grid: token(styles, '--card-border', fallbackTheme.grid),
    text: token(styles, '--text-primary', fallbackTheme.text),
    muted: token(styles, '--text-secondary', fallbackTheme.muted),
    danger: token(styles, '--danger', fallbackTheme.danger),
  };
};

export const formatChartAmount = (value) => (Number(value) || 0).toLocaleString(undefined, {
  maximumFractionDigits: 2,
});
